function getMarket(market) {
	switch (market*1) {
    case 100:
      return "SH"
      break;
    case 101:
      return "SZ"
      break;
    case 103:
    case 104:
    case 105:
      return "US"
      break;
    case 106:
      return "HK"
      break;
    default:
      return "SZ"
  }
}

module.exports={
	getMarket:getMarket,
}



//////////////////
// WEBPACK FOOTER
// ./src/module/helper/stock.js
// module id = 19
// module chunks = 0